import { NextResponse } from "next/server";

export class R {
	static raw<T = {}>(data: T, init?: ResponseInit) {
		return NextResponse.json(data, init);
	}

	static notFound(message = "请求路径有误", init?: ResponseInit) {
		return NextResponse.json(
			{
				code: 404,
				message,
			},
			init ?? {
				status: 404,
			}
		);
	}

	static ok<T>(data?: T, init?: ResponseInit) {
		return R.raw(
			{
				code: 200,
				message: "Ok",
				...(data ? { data } : {}),
			},
			init
		);
	}

	static bad(message = "请求参数有误", init?: ResponseInit) {
		return R.raw(
			{
				code: 400,
				message,
			},
			init
		);
	}

	static forbidden(message = "访问受限，权限不足", init?: ResponseInit) {
		return R.raw(
			{
				code: 403,
				message,
			},
			init
		);
	}

	static error(message = "服务内部错误", init?: ResponseInit) {
		return R.raw(
			{
				code: 500,
				message,
			},
			init
		);
	}
}
